import { createApiHooks, httpStatusAsData, schemaToQueryParameters } from '@apis/next/common';
import { Contact, ContactSearchQuery, PatchContact, PostContact } from '@models/next/Contact';
import { z } from 'zod';

export const contactApis = createApiHooks('/contact', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(ContactSearchQuery),
    response: Contact.array(),
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: Contact.nullable(),
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PatchContact,
      },
    ],
    response: Contact,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostContact,
      },
    ],
    response: Contact,
  },
  {
    method: 'delete',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: z.unknown(),
  },
]);

export const dashboardContactApis = createApiHooks('/dashboard/contact', [
  {
    path: '/',
    method: 'get',
    parameters: schemaToQueryParameters(ContactSearchQuery),
    response: z.array(Contact),
  },
  {
    path: '/:id',
    method: 'get',
    response: Contact.nullable(),
  },
]);

dashboardContactApis.client.use('get', '/dashboard/contact/:id', httpStatusAsData(404, null));

contactApis.client.use('get', '/contact/:id', httpStatusAsData(404, null));
